<ng-container *ngIf="(isCountryBlocked === false || !isCountryBlocked ) && !isAccountLocked && !maintenanceStatus">
  <div class="main-pages_loader loading-div" *ngIf="loading || !this.countryDataService.ipCountry">
    <div class='loader loader-large'></div>
    <app-pace-loader></app-pace-loader>
  </div>
  <div class="home_page--container" [ngClass]=" ( isGameLaunch ) ? 'gameHeader': ''">

    <!-- Header Left Container Start -->
    <div class="home_page--container_left">
      <app-header (loaderStatus)="updateloader()"></app-header>
    </div>
    <!-- Header Left Container End -->

    <!-- Main Content Right Container Start -->
    <div class="home_page--container_right col-md-10 p0" [ngClass]=" ( isGameLaunch ) ? 'gameHeader': ''">
      <div class="main_wrapper" [ngClass]=" ( isGameLaunch || isLogin  || isForgotPwd ) ? 'remove-pad': ''">
        <!-- <app-timer-banner></app-timer-banner> -->
        <app-notification *ngIf="this.countryDataService.ipCountry"></app-notification>
        <div [style.display]="loading ? 'none' : 'block'" *ngIf="this.countryDataService.ipCountry && ( gameplayWindowMinimized || !showGameplayWindow) ">
          <router-outlet (activate)='onActivate($event)'></router-outlet>
        </div>
        <app-gamingwindow *ngIf="showGameplayWindow" [isGameminimized]="gameplayWindowMinimized"></app-gamingwindow>
      </div>

      <app-nav-panel></app-nav-panel>

      <!-- [ngClass]="isGameLaunch ? 'hide': 'show'" -->
      <div class="footer" [ngClass]="[isLogin ? 'hide-below-992': '', isCashierpage ? 'show-below-992': '', isBonuses ? 'show-below-992': '']">
        <app-footer [isLoggedIn]="isLoggedIn" [ishomePage]="ishomePage"
          [ngClass]="(footerDisable === true && !landingPage) ? 'show' : 'hide'"></app-footer>
        <!-- <app-footer-svg></app-footer-svg> -->
      </div>
      <app-footerstickynav *ngIf="windowType === 'tab'" [ngClass]=" ( isRegister ) ? 'hide-below-992': ''"></app-footerstickynav>
    </div>
    <!-- Main Content Right Container End -->
    <div class="clear clearfix"></div>
    

  </div>

  <div *ngIf="serverErrorMsg && serverErrorMsg.length !== 0">
    <div class="server_err_msg" id="serverErrorPopUp">
      <button type="button" class="ser_close" data-dismiss="modal" aria-label="Close" (click)="closeServsErr()">
        <span aria-hidden="true">
          <i class="icon-cancel-1"></i>
        </span>
      </button>
      <p class="defaulterror_msg" *ngIf="!accountStatusMsgs">{{'appComp.comp1' | translate}}</p>
      <p class="defaulterror_msg" *ngIf="accountStatusMsgs">{{'appComp.comp2' | translate}}</p>
      <div class="servermessage" [innerHTML]="serverErrorMsg"></div>
      <span>
        <a href="javascript:void(0)" *ngIf="!accountStatusMsgs"
          (click)="closeServsErr()">{{'appComp.comp3' | translate}}</a>
      </span>
    </div>
  </div>

  <div *ngIf="customServerErrorMsg && customServerErrorMsg.length !== 0">
    <div class="server_err_msg" id="customServerErrorPopUp">
      <button type="button" class="ser_close" data-dismiss="modal" aria-label="Close" (click)="closeCustomServsErr()">
        <span aria-hidden="true">
          <i class="icon-cancel-1"></i>
        </span>
      </button>
      <div class="servermessage" [innerHTML]="customServerErrorMsg"></div>
    </div>
  </div>

  <!-- Session Expriy Modal -->
  <modal id="sessionExpiredModal" class="modal_smooth_open" *ngIf="gamingSession">
    <div class="fixed-scroll">
      <div class="site_modal middleAlignBlock">
        <div class="middleAlign">
          <div class="site_modal--body site_modal--body-small game_reality_checkblock">
            <h5> {{'appComp.comp4' | translate}}</h5>
            <div class="session-expiry-content">
              <div class="game_alert_box">
                <span class="fi custom-error_warning"></span>
                <h4>{{'appComp.comp5' | translate}} {{name}}!</h4>
                <p> {{'appComp.comp6' | translate}} {{sessionLimit}} {{'appComp.comp7' | translate}}</p>
              </div>
              <ul class="session-expiry-options">
                <li (click)="sessionContinue()">
                  <a> {{'appComp.comp8' | translate}}</a>
                </li>
                <li (click)="moveToTransaction()">
                  <a>
                    {{'appComp.comp9' | translate}}
                    <span> {{'appComp.comp10' | translate}}{{userService.getUserCurrencySymbol()}}
                      {{userService.getUserCashBalance() | number:'1.2-2'}} </span>
                  </a>
                </li>
                <li (click)="moveToRealityCheck()">
                  <a> {{'appComp.comp11' | translate}}</a>
                </li>
                <li (click)="logout('sessionExpiredModal')">
                  <a>{{'appComp.comp12' | translate}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</ng-container>

<!-- Maintenance Page -->
<ng-container *ngIf="maintenanceStatus">
  <app-maintenance></app-maintenance>
</ng-container>

<!-- Country Blocked -->
<ng-container *ngIf="isCountryBlocked" class="cnt_block">
  <app-country-blocked></app-country-blocked>
</ng-container>
<app-blocked-user></app-blocked-user> 
<app-widget *ngIf="tugichatEnabled"></app-widget>
<!-- Hided Instant banner -->
<!-- <ng-container *ngIf="showBanner">
  <app-instant-banner [userInfo]="userDetailsForBanner"></app-instant-banner>
</ng-container> -->
